export default __webpack_public_path__ + "static/media/fsw_3.3cdabc9e.png";